import axios, { InternalAxiosRequestConfig } from 'axios';
import { sha256 } from 'js-sha256';
import { v4 as uuidv4 } from 'uuid';
import { getLanguageCookie } from '@store/InternationalizationProvider';
import { handleResponseError } from './handleResponse';

export const authAxios = axios.create();
const apiAxios = axios.create();

const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId');
  if (deviceId) {
    return deviceId;
  }
  deviceId = uuidv4();
  localStorage.setItem('deviceId', deviceId);
  return deviceId;
};

const createSig = (config: InternalAxiosRequestConfig): string => {
  if (!config.method || !config.url) {
    return '';
  }
  const method = config.method.toUpperCase();
  const path = escape(config.url);
  const apiKey = process.env.REACT_APP_BOOKLA_API_KEY;
  const deviceId = getDeviceId();
  const sig = `${method};${path};${apiKey};${deviceId}`;
  return sha256(sig);
};

const signRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  config.headers.set('SpendoApp', process.env.REACT_APP_BOOKLA_APP_ORIGIN);
  config.headers.set('SpendoDeviceID', getDeviceId());
  config.headers.set('SpendoSig', createSig(config));
  config.headers.set('Accept-Language', getLanguageCookie());
  return config;
};

authAxios.defaults.baseURL = process.env.REACT_APP_BOOKLA_API_BASE_URL;
authAxios.interceptors.request.use(signRequestInterceptor);
authAxios.interceptors.response.use(undefined, handleResponseError);

apiAxios.defaults.baseURL = process.env.REACT_APP_BOOKLA_API_BASE_URL;
apiAxios.interceptors.request.use(signRequestInterceptor);
apiAxios.interceptors.response.use(undefined, handleResponseError);

export default apiAxios;
